import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./About.css";

const About: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="about" className="about">
      <div className="about-container">
        <motion.div ref={ref} className="about-content" initial={{ opacity: 0, y: 50 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }}>
          <motion.h2 className="section-title" initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, delay: 0.2 }}>
            Sobre Mí
          </motion.h2>

          <div className="about-grid">
            <motion.div className="about-text" initial={{ opacity: 0, x: -50 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.8, delay: 0.4 }}>
              <h3>¿Quién soy?</h3>
              <p>Soy un desarrollador Full Stack apasionado por la tecnología y la innovación. Me especializo en crear aplicaciones web modernas y funcionales utilizando las últimas tecnologías del mercado.</p>

              <p>Mi enfoque se centra en desarrollar soluciones que no solo sean técnicamente sólidas, sino también intuitivas y accesibles para todos los usuarios. Me gusta escribir código limpio, mantenible y escalable.</p>
            </motion.div>

            <motion.div className="about-stats" initial={{ opacity: 0, x: 50 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.8, delay: 0.6 }}>
              <div className="stat-item">
                <h4>4+</h4>
                <p>Años de experiencia</p>
              </div>

              <div className="stat-item">
                <h4>3+</h4>
                <p>Proyectos completados</p>
              </div>

              <div className="stat-item">
                <h4>6+</h4>
                <p>Tecnologías dominadas</p>
              </div>

              <div className="stat-item">
                <h4>100%</h4>
                <p>Compromiso con la calidad</p>
              </div>
            </motion.div>
          </div>

          <motion.div className="about-values" initial={{ opacity: 0, y: 50 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, delay: 0.8 }}>
            <h3>Mis Valores</h3>
            <div className="values-grid">
              <div className="value-item">
                <h4>Innovación</h4>
                <p>Busco constantemente nuevas formas de resolver problemas y mejorar la experiencia del usuario.</p>
              </div>

              <div className="value-item">
                <h4>Calidad</h4>
                <p>Me comprometo a entregar código de alta calidad, bien estructurado y fácil de mantener.</p>
              </div>

              <div className="value-item">
                <h4>Colaboración</h4>
                <p>Valoro el trabajo en equipo y la comunicación efectiva para lograr los mejores resultados.</p>
              </div>

              <div className="value-item">
                <h4>Aprendizaje Continuo</h4>
                <p>Me mantengo actualizado con las últimas tecnologías y mejores prácticas del desarrollo.</p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
